import { render, staticRenderFns } from "./HIForm.vue?vue&type=template&id=44bea378&"
import script from "./HIForm.vue?vue&type=script&lang=js&"
export * from "./HIForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports